import { Component, Inject, OnInit, ViewChild,EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DBasicosParametricasServicios, DValorPeriodico, DValorDominio } from '@dian/api-basicos-parametricas';

import { DNotificacionServicio } from '@dian-cmp/notificaciones';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_424';
const VAL_PERIODICO_110 = 110;
const ANNIODECLARACION = 2022;

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: 'Arrendamientos', listHelp: ['394'] },
  { text: "2", active: false, completed: false, tooltip: 'Intereses terceros', listHelp: ['395'] },
  { text: "3", active: false, completed: false, tooltip: 'Regalias propiedad intelectual', listHelp: ['396'] },
  { text: "4", active: false, completed: false, tooltip: 'Rendimientos financieros', listHelp: ['397'] },
  { text: "5", active: false, completed: false, tooltip: 'Retiro ahorros', listHelp: ['398'] },
  { text: "6", active: false, completed: false, tooltip: 'Valor retiro ahorros', listHelp: ['399'] },
  { text: "7", active: false, completed: false, tooltip: 'Aportes de salud', listHelp: ['402'] },
  { text: "8", active: false, completed: false, tooltip: 'Fondos de pensión', listHelp: ['403'] },
  { text: "9", active: false, completed: false, tooltip: 'RAIS', listHelp: ['404'] },
  { text: "10", active: false, completed: false, tooltip: 'Costos y gastos', listHelp: ['406'] },
  { text: "11", active: false, completed: false, tooltip: 'ECE', listHelp: ['407'] },
  { text: "12", active: false, completed: false, tooltip: 'Valor ECE', listHelp: ['408'] },
  { text: "13", active: false, completed: false, tooltip: 'Aportes voluntarios pensión', listHelp: ['409'] },
  { text: "14", active: false, completed: false, tooltip: 'Rentas de capital Comunidad andina', listHelp: ['411'] },
  { text: "15", active: false, completed: false, tooltip: 'Interés vivienda', listHelp: ['412'] },
  { text: "16", active: false, completed: false, tooltip: 'ICETEX', listHelp: ['414'] },
  { text: "17", active: false, completed: false, tooltip: 'Aportes voluntarios cesantías', listHelp: ['419'] },
  { text: "18", active: false, completed: false, tooltip: 'Donación investigación', listHelp: ['416'] },
  { text: "19", active: false, completed: false, tooltip: '4x1000', listHelp: ['417'] },
  { text: "20", active: false, completed: false, tooltip: 'Perdidas', listHelp: ['421'] },
  { text: "21", active: false, completed: false, tooltip: 'Valor Perdidas', listHelp: ['422'] }
];

@Component({
  selector: 'app-renta-capital-modal',
  templateUrl: './renta-capital-modal.component.html',
  styleUrls: ['./renta-capital-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio,
    DBasicosParametricasServicios, 
    DValorPeriodico, 
    DValorDominio 
  ]
})
export class RentaCapitalModalComponent extends HandlerModal implements OnInit {

  @ViewChild('buttonRight') buttonRight: any;
  saveModel = new EventEmitter();
  public showSave:boolean;
  public UVT:string='';

  constructor(
    public dialogRef: MatDialogRef<RentaCapitalModalComponent>,
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    private dBasicosParametricasServicios: DBasicosParametricasServicios,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    console.log(model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.validateBtnRightActive();
    this.validateShowSave();
    this.obtenerValorPeriodico110();
  
  }

  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cs_id_394 == undefined)this.model.doc.cuerpo.cs_id_394="0";
    if(this.model.doc.cuerpo.cs_id_395 == undefined)this.model.doc.cuerpo.cs_id_395="0";
    if(this.model.doc.cuerpo.cs_id_396 == undefined)this.model.doc.cuerpo.cs_id_396="0";
    if(this.model.doc.cuerpo.cs_id_397 == undefined)this.model.doc.cuerpo.cs_id_397="0";
    if(this.model.doc.cuerpo.cs_id_401 == undefined)this.model.doc.cuerpo.cs_id_401="0";
    if(this.model.doc.cuerpo.cs_id_398 == undefined)this.model.doc.cuerpo.cs_id_398=null;
    if(this.model.doc.cuerpo.cs_id_399 == undefined)this.model.doc.cuerpo.cs_id_399="0";
    if(this.model.doc.cuerpo.cs_id_400 == undefined)this.model.doc.cuerpo.cs_id_400="0";
    if(this.model.doc.cuerpo.cs_id_402 == undefined)this.model.doc.cuerpo.cs_id_402="0";
    if(this.model.doc.cuerpo.cs_id_403 == undefined)this.model.doc.cuerpo.cs_id_403="0";
    if(this.model.doc.cuerpo.cs_id_404 == undefined)this.model.doc.cuerpo.cs_id_404="0";
    if(this.model.doc.cuerpo.cs_id_405 == undefined)this.model.doc.cuerpo.cs_id_405="0";
    if(this.model.doc.cuerpo.cs_id_406 == undefined)this.model.doc.cuerpo.cs_id_406="0";
    if(this.model.doc.cuerpo.cs_id_407 == undefined)this.model.doc.cuerpo.cs_id_407=null;
    if(this.model.doc.cuerpo.cs_id_408 == undefined)this.model.doc.cuerpo.cs_id_408="0";
    if(this.model.doc.cuerpo.cs_id_409 == undefined)this.model.doc.cuerpo.cs_id_409="0";
    if(this.model.doc.cuerpo.cs_id_410 == undefined)this.model.doc.cuerpo.cs_id_410="0";
    if(this.model.doc.cuerpo.cs_id_411 == undefined)this.model.doc.cuerpo.cs_id_411="0";
    if(this.model.doc.cuerpo.cs_id_412 == undefined)this.model.doc.cuerpo.cs_id_412="0";
    if(this.model.doc.cuerpo.cs_id_413 == undefined)this.model.doc.cuerpo.cs_id_413="0";
    if(this.model.doc.cuerpo.cs_id_414 == undefined)this.model.doc.cuerpo.cs_id_414="0";
    if(this.model.doc.cuerpo.cs_id_415 == undefined)this.model.doc.cuerpo.cs_id_415="0";
    if(this.model.doc.cuerpo.cs_id_419 == undefined)this.model.doc.cuerpo.cs_id_419="0";
    if(this.model.doc.cuerpo.cs_id_420 == undefined)this.model.doc.cuerpo.cs_id_420="0";
    if(this.model.doc.cuerpo.cs_id_416 == undefined)this.model.doc.cuerpo.cs_id_416="0";
    if(this.model.doc.cuerpo.cs_id_417 == undefined)this.model.doc.cuerpo.cs_id_417="0";
    if(this.model.doc.cuerpo.cs_id_418 == undefined)this.model.doc.cuerpo.cs_id_418="0";
    if(this.model.doc.cuerpo.cs_id_421 == undefined)this.model.doc.cuerpo.cs_id_421=null;
    if(this.model.doc.cuerpo.cs_id_422 == undefined)this.model.doc.cuerpo.cs_id_422="0";
  }

  
  
  //////////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO que bloquean el avance
  public validateRbQuestions(val: string) {
    console.log(this.indexStepper + " - " +val);
    switch (this.indexStepper) {
      case 4://rc15RetiroAhorros?
        if(val == "0"){
          if(this.validateHasModalValues(this.indexStepper)){
            this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"Está modificando su respuesta a 'No', pero ya existen datos ingresados para esta pregunta. Si confirma, los datos anteriores serán eliminados. ¿Está seguro de continuar?").afterClosed().subscribe(result => {
              if (result) {
                this.cleanModalValues(this.indexStepper);
                this.model.doc.cuerpo.cs_id_398 = val;
                //this.changeStepLocal(this.indexStepper+2);
              }
            });
          }else{
            this.model.doc.cuerpo.cs_id_398 = val;
          }
        }else{
          this.model.doc.cuerpo.cs_id_398 = val;
        }
        //Si ha seleccionado respuesta SI/NO en rc15RetiroAhorros habilitar botón next
        if(val!=undefined && val!=""){
          this.buttonRight.nativeElement.disabled = false;
        }
        break;
      case 10://rc110RentasPasivas?
        if(val == "0"){
          if(this.validateHasModalValues(this.indexStepper)){
            this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"Está modificando su respuesta a 'No', pero ya existen datos ingresados para esta pregunta. Si confirma, los datos anteriores serán eliminados. ¿Está seguro de continuar?").afterClosed().subscribe(result => {
              if (result) {
                this.cleanModalValues(this.indexStepper);
                this.model.doc.cuerpo.cs_id_407 = val;
                //this.changeStepLocal(this.indexStepper+2);
              }
            });
          }else{
            this.model.doc.cuerpo.cs_id_407 = val;
          }
        }else{
          this.model.doc.cuerpo.cs_id_407 = val;
        }
        //Si ha seleccionado respuesta SI/NO en rc110RentasPasivas habilitar botón next
        if(val!=undefined && val!=""){
          this.buttonRight.nativeElement.disabled = false;
        }
        break;

        case 19:
        if(val == "0"){
          if(this.validateHasModalValues(this.indexStepper)){
            this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"Está modificando su respuesta a 'No', pero ya existen datos ingresados para esta pregunta. Si confirma, los datos anteriores serán eliminados. ¿Está seguro de continuar?").afterClosed().subscribe(result => {
              if (result) {
                this.cleanModalValues(this.indexStepper);
                this.model.doc.cuerpo.cs_id_421 = val;
                //this.changeStepLocal(this.indexStepper+2);
              }
            });
          }else{
            this.model.doc.cuerpo.cs_id_421 = val;
          }
          this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=VAL_INDICADOR_COMPLETO;
          this.updateIndicadorAvance();
          this.validateShowSave();
        }else{
          this.model.doc.cuerpo.cs_id_421 = val;
        }
        //Si ha seleccionado respuesta SI/NO en rc110RentasPasivas habilitar botón next
        if(val!=undefined && val!="" && val!="0"){
          this.buttonRight.nativeElement.disabled = false;
        }else{
          this.buttonRight.nativeElement.disabled = true;

        }
        break;
    }
    console.log(this.model);
  }

  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
    switch(indexQuestion){//Pregunta Actualizar Valor despues de pregunta SI/NO
      case 4:
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_399, "0")){
          hasValues=true;
        }
        break;
      case 10:
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_408, "0")){
          hasValues=true;
        }
        break;
      case 19:
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_422, "0")){
          hasValues=true;
        }
        break;
    }
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    switch(indexQuestionModal){//Pregunta Actualizar Valor despues de pregunta SI/NO
      case 4:
        this.model.doc.cuerpo.cs_id_399="0";
        break;
      case 10:
        this.model.doc.cuerpo.cs_id_408="0";
        break;
      case 19:
        this.model.doc.cuerpo.cs_id_422="0";
        break;
      default:
        break;
    }
    console.log(this.model);
  }
  
  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateStepHabilitado(indexS:number):boolean{
    let habilitado = true;
    
    //Si no ha respondido en rc15RetiroAhorros no puede saltar preguntas
    if( (indexS>=5 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_398==undefined || this.model.doc.cuerpo.cs_id_398=="")) ){
      habilitado = false;
    }
    //Si responde 'NO' en rc15RetiroAhorros debe saltar preguntas del indexStepper 
    else if( (indexS==5 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_398=="0")) ){
      habilitado = false;
    }

    //Si no ha respondido en rc110RentasPasivas no puede saltar preguntas
    if( (indexS>=11 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_407==undefined || this.model.doc.cuerpo.cs_id_407=="")) ){
      habilitado = false;
    }
    //Si responde 'NO' en rc110RentasPasivas debe saltar preguntas del indexStepper 
    else if( (indexS==11 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_407=="0")) ){
      habilitado = false;
    }

    //Si no ha respondido en rc117Perdidas no puede saltar preguntas
    if( (indexS>=20 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_421==undefined || this.model.doc.cuerpo.cs_id_421=="")) ){
      habilitado = false;
    }
    //Si responde 'NO' en rc117Perdidas debe saltar preguntas del indexStepper 
    else if( (indexS==20 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_421=="0")) ){
      habilitado = false;
    }

    return habilitado;
  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateBtnRightActive(){
    switch(this.indexStepper){
      case 4:
        //Si no se ha seleccionado respuesta SI/NO en rc15RetiroAhorros deshabilitar botón next
        if( this.model.doc.cuerpo.cs_id_398==undefined || this.model.doc.cuerpo.cs_id_398=="" ){
          this.buttonRight.nativeElement.disabled = true;  
        }else{
          this.buttonRight.nativeElement.disabled = false;
        }
        break;
      case 10:
        //Si no se ha seleccionado respuesta SI/NO en rc110RentasPasivas deshabilitar botón next
        if( this.model.doc.cuerpo.cs_id_407==undefined || this.model.doc.cuerpo.cs_id_407=="" ){
          this.buttonRight.nativeElement.disabled = true;  
        }else{
          this.buttonRight.nativeElement.disabled = false;
        }
        break;
      case 19:
        //Si no se ha seleccionado respuesta SI/NO en rc110RentasPasivas deshabilitar botón next
        if( this.model.doc.cuerpo.cs_id_421==undefined || this.model.doc.cuerpo.cs_id_421=="" || this.model.doc.cuerpo.cs_id_421=="0" ){
          this.buttonRight.nativeElement.disabled = true;  
        }else{
          this.buttonRight.nativeElement.disabled = false;
        }
        break;
      default:
        this.buttonRight.nativeElement.disabled = false;
        break;
    }
    
  }
  


  //////////////////////////
  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
  
  protected updateIndicadorAvance(){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(this.indexStepper> Number(casIndicadorAvance)){
      let indexS = this.indexStepper+1;
      while(!this.validateStepHabilitado(indexS)){
        indexS++;
      }
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=indexS.toString();
    }
    if(this.indexStepper==this.stepsList.length-1){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=VAL_INDICADOR_COMPLETO;
    }
  }

  protected controlStep(direction: DirectionType): void {
    let indexS = this.indexStepper;
    while(!this.validateStepHabilitado(indexS)){
      if(direction==DirectionType.previous ){
          indexS--;
      }
      if(direction==DirectionType.next){
          indexS++;
      }
    }
    this.changeStepLocal(indexS, true);
  }

  public changeStepLocal(index: number, forceUpdateStepper?:boolean){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(forceUpdateStepper){
      this.changeStep(index);
      this.updateIndicadorAvance();
    }else if(this.validateStepHabilitado(index)){
      let indexCalc = index-1;
      if(indexCalc<=Number(casIndicadorAvance)){
        this.changeStep(index);
        this.updateIndicadorAvance();
      }else{
        console.log("Avance no permitido: casIndicadorAvance=" + casIndicadorAvance + ", index-1="+(indexCalc));
      }
    }
    this.validateBtnRightActive();
    this.validateShowSave();
  }

  public closeModal(){
    this.changeStepLocal(0);
    this.dialogRef.close("");
  }

  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO){ this.showSave=true };
  }
  public guardar(){
    console.log(this.model)
    this.saveModel.emit(true);
    if(this.indexStepper==this.stepsList.length-1 || this.indexStepper==19 && this.model.doc.cuerpo.cs_id_421=="0"){
      this.closeModal();
    }
  }

  public operaciones(numCas?:number,soloEstaCasilla?:boolean):void {
    switch (numCas) {
     
      case 394:
        this.operacionCs394();
        break;
      case 395:
        this.operacionCs395();
        break;
      case 396:
        this.operacionCs396();
        break;
      case 397:
        this.operacionCs397();
        break;  
      case 399:
        this.operacionCs399();
        break;         
      case 401:
        this.operacionCs401();
        break;     
      case 398:
        this.operacionCs398();
        break;  
      
      case 400:
        this.operacionCs400();
        break; 
      
      case 412:
        this.operacionCs412();
        break; 
      case 413:
        this.operacionCs413();
        break; 
      case 414:
        this.operacionCs414();
        break; 
      case 415:
        this.operacionCs415();
        break; 
      case 416:
        this.operacionCs416();
        break; 
      case 417:
        this.operacionCs417();
        break;                 
      case 418:
        this.operacionCs418();
        break;      
      case 421:
        this.operacionCs421();
        break;       
      case 422:
        this.operacionCs422();
        break;       
   }
    if(soloEstaCasilla)return;

    //Operaciones
    let resultado = "0";
    
  }

 
  
  operacionCs394(){
    this.operacionCs400();
  }

  operacionCs395(){
    this.operacionCs400();
  }
  
  operacionCs396(){
    this.operacionCs400();
  }
  
  operacionCs397(){
    this.operacionCs400();
  }
  
  operacionCs401(){
    this.model.doc.cuerpo.cs_id_401 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_401,true);
      if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_401, this.model.doc.cuerpo.cs_id_397)){
        this.dNotificacionServicio.mostrarDialogoInformacion('El valor NO gravado no puede ser mayor que sus ingresos por rendimientos financieros');
        this.model.doc.cuerpo.cs_id_401 = this.model.doc.cuerpo.cs_id_397;
      }
  }
  
  operacionCs398(){
    const cas398 = this.model.doc.cuerpo.cs_id_398;
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas398,"0")) {
      this.model.doc.cuerpo.cs_id_399="0";
    }
  }
  
  operacionCs399(){
    this.operacionCs400();
  }
 
  
  operacionCs400(){
    const datosC400 = ['cs_id_394','cs_id_395','cs_id_396','cs_id_397','cs_id_399'];
    const cas400 = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA,this.model, datosC400, true);
      this.model.doc.cuerpo.cs_id_400 = cas400;
  }
  
 
  
  operacionCs412(){
    const cas412 = this.model.doc.cuerpo.cs_id_412;
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas412,"0")) {
      
      //si ya esta diligenciada en otra renta entonces colocar en cero
      const cas258 = this.model.doc.cuerpo.cs_id_258;
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas258,"0")) {
        this.model.doc.cuerpo.cs_id_412="0";
        this.model.doc.cuerpo.cs_id_413="0";
        this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas de trabajo como asalariado");
        return
      }
  
      const cas291 = this.model.doc.cuerpo.cs_id_291;
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas291,"0")) {
        this.model.doc.cuerpo.cs_id_412="0";
        this.model.doc.cuerpo.cs_id_413="0";
        this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas de trabajo como trabajador independiente");
        return
      }
      
      const cas325 = this.model.doc.cuerpo.cs_id_325;
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas325,"0")) {
        this.model.doc.cuerpo.cs_id_412="0";
        this.model.doc.cuerpo.cs_id_413="0";
        this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas por honorarios");
        return
      }
      
      const cas519 = this.model.doc.cuerpo.cs_id_519;
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas519,"0")) {
        this.model.doc.cuerpo.cs_id_412="0";
        this.model.doc.cuerpo.cs_id_413="0";
        this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas no laborales");
        return
      }
    }
    
    this.operacionCs413();
  }
  
  
  operacionCs413(){
    const cas412 = this.model.doc.cuerpo.cs_id_422;
    let uvt1200 = "45605000";
    if(this.UVT != '')
    {
      uvt1200=this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,this.UVT,'1200');
    }
    if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas412,uvt1200)) {
      this.model.doc.cuerpo.cs_id_413 = cas412;
    } else {
      this.model.doc.cuerpo.cs_id_413 = uvt1200;
    }
  }
  
  
  operacionCs414(){
    const cas414 = this.model.doc.cuerpo.cs_id_414;
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas414,"0")) {
      
      //si ya esta diligenciada en otra renta entonces colocar en cero
      const cas260 = this.model.doc.cuerpo.cs_id_260;
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas260,"0")) {
        this.model.doc.cuerpo.cs_id_414="0";
        this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas de trabajo como asalariado");
        return
      }
   
      const cas293 = this.model.doc.cuerpo.cs_id_293;
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas293,"0")) {
        this.model.doc.cuerpo.cs_id_414="0";
        this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas de trabajo como trabajador independiente");
        return
      }
      
      const cas327 = this.model.doc.cuerpo.cs_id_327;
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas327,"0")) {
        this.model.doc.cuerpo.cs_id_414="0";
        this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas por honorarios");
        return
      }
      
      const cas521 = this.model.doc.cuerpo.cs_id_521;
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas521,"0")) {
        this.model.doc.cuerpo.cs_id_414="0";
        this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas no laborales");
        return
      }
    }
    
    this.operacionCs415();
  }
  
  
  operacionCs415(){
    const cas414 = this.model.doc.cuerpo.cs_id_414;
    let uvt100 = "3800000";
    if(this.UVT != '')
    {
      uvt100=this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,this.UVT,'100');
    }
    if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas414,uvt100)) {
      this.model.doc.cuerpo.cs_id_415 = cas414;
    } else {
      this.model.doc.cuerpo.cs_id_415 = uvt100;
    }
  }

  //donacion para investigacion
operacionCs416(){
	
	const cas416 = this.model.doc.cuerpo.cs_id_416;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas416,"0")) {
		
		//si ya esta diligenciada en otra renta entonces colocar en cero
		const cas271 = this.model.doc.cuerpo.cs_id_271;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas271,"0")) {
			this.model.doc.cuerpo.cs_id_416="0";
			this.dNotificacionServicio.mostrarDialogoInformacion('Ya reportó por esta deducción en las rentas de trabajo como asalariado');
			return;
		}
		

		const cas303 = this.model.doc.cuerpo.cs_id_303;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas303,"0")) {
			this.model.doc.cuerpo.cs_id_416="0";
			this.dNotificacionServicio.mostrarDialogoInformacion('Ya reportó por esta deducción en las rentas de trabajo como trabajador independiente');
			return;
		}
		
		const cas337 = this.model.doc.cuerpo.cs_id_337;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas337,"0")) {
			this.model.doc.cuerpo.cs_id_416="0";
			this.dNotificacionServicio.mostrarDialogoInformacion('Ya reportó por esta deducción en las rentas por honorarios');
			return
		}
		
		const cas523 = this.model.doc.cuerpo.cs_id_523;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas523,"0")) {
			this.model.doc.cuerpo.cs_id_416="0";
			this.dNotificacionServicio.mostrarDialogoInformacion('Ya reportó por esta deducción en las rentas no laborales');
			return
		}
	}
}
  
  operacionCs417(){
    this.operacionCs418();
  }
  
  
  operacionCs418(){
    const porcentajeTopeMax = "0.50";
    const cas417 = this.model.doc.cuerpo.cs_id_417;
    const resultado =  this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,this.model.doc.cuerpo.cs_id_417,porcentajeTopeMax);
    this.model.doc.cuerpo.cs_id_418 = this.dutilidades.redondearValorMoneda(resultado ,true);
    
  }
  
  operacionCs421(){
    const cas421 = this.model.doc.cuerpo.cs_id_421;
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas421,"0")) {
      this.model.doc.cuerpo.cs_id_422="0";
    }
  }
  operacionCs422(){
    const cas422 = this.model.doc.cuerpo.cs_id_422;
      if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas422,"0")) {
      this.dNotificacionServicio.mostrarDialogoInformacion("El valor de las pérdidas a compensar no puede ser cero");
        return;
     }
    
     //Otras validaciones se realizan en el 210
  }

   /**
    * @desc Funcion para obtener los valores del modelo e operar con ellos
    * @param {DTipoOperacionAritmetica} operacion
    * @param {DDocumento} modelo
    * @param {Array<string>} campos
    * @param {boolean} formatear
    * @return {String}
    */
    protected operarCamposCuerpo(operacion: DTipoOperacionAritmetica, modelo: DDocumento, campos: Array<string>, formatear: boolean): string {                    
      let valores = [];
      for (let i in campos) {
          if (this.dutilidades.validarValorNumerico(modelo.doc.cuerpo[campos[i]])) {
              let valor = this.dutilidades.redondearValorMoneda(modelo.doc.cuerpo[campos[i]]);            
              valores.push(valor);
              //valores.push(modelo.doc.cuerpo[campos[i]]);
          } else {
              valores.push('0');
          }
      }
      return this.dutilidades.ejecutarOperacionMultipleValores(valores, operacion, formatear);
  }
  //UVT 
  private obtenerValorPeriodico110(): void {
    this.dBasicosParametricasServicios.obtenerValorPeriodico(VAL_PERIODICO_110, ANNIODECLARACION).subscribe(
      data => this.setObjectFromResponse(data),
      error => console.log(error)
    )
  }
  private setObjectFromResponse(data: any): void {
    
        let model=<DValorPeriodico>data;
        this.UVT = String(model.valor);
     
  }
  
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/renta-capital/renta-capital/renta-capital-modal.component.ts